export const mensurationQuestions = {
	waterTreatment: {
		id: "waterTreatment",
		steps: {
			"1": { // 1.1.1
				id: "1",
				type: "tableYear",
				label: "Qual o volume de água em metros cúbicos (m³) utilizados por mês na empresa, no ano de " + ((new Date()).getFullYear()),
				options: [
					{label: "", id: "waterVolume"}
				]
			},
			"2-1": { // 1.1.1.2
				id: "2-1",
				type: "specialRangeInput",
				label: "Indique o percentual (%) da quantidade total de água captada por fonte",
				options: [
					{ 
						mask: "%", 
						label: "Água Superficial (Rios / Lagos)", 
						id: "aboveGroundWater",  
						minRange: "0", 
						maxRange: "100"
					},
					{ 
						mask: "%", 
						label: "Água Subterrâneas (Lençóis Freáticos/ Aquíferos)", 
						id: "subterraneanWater",  
						minRange: "0", 
						maxRange: "100"
					},
					{ 
						mask: "%", 
						label: "Abastecimento público (COPASA)", 
						id: "publicSupply", 
						minRange: "0", 
						maxRange: "100"
					},
					{ 
						mask: "%", 
						label: "Água de chuva", 
						id: "rainWater", 
						minRange: "0", 
						maxRange: "100"
					},
					{ 
						mask: "%", 
						label: "Água de reúso / reaproveitamento", 
						id: "reusedWater", 
						minRange: "0", 
						maxRange: "100"
					},
				],
			},
			"2-2": { // 1.1.1.3
				id: "2-2",
				type: "textArea",
				label: "Descreva quais são os usos para a água de reaproveitamento ou reúso.",
				options: [
					{id: "description", label: "Resposta."}
				]
				
			},
			"3": { // 1.1.2
				id: "3",
				type: "rangeInput",
				label: "Qual a representatividade do custo da água frente a todos os custos da empresa em percentual (%)",
				options: [
					{ mask: "%", label: "", id: "aboveGroundWater",  minRange: "0", maxRange: "100"},
				],
			}
		}
	},
	measurementSectorization: {
		id: "measurementSectorization",
		steps: {
			"1": { // 1.2.1
				id: "1",
				type: "radio",
				label: "A empresa faz medições ou estimativa de consumo de água em diferentes setores? Exemplos: prédios administrativos, diferentes processos da indústria, áreas externas, etc.",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"1-1": { // 1.2.1.2
				id: "1-1",				
				type: "radio",
				label: "Qual o método de medição dos diferentes setores da empresa?",
				options: [
					{ label: "Estimativa por técnicos da empresa", id: "E"},
					{ label: "Medição real com hidrômetros setorizados em cada área e anotação manual por técnicos da empresa", id: "M"},
					{ label: "Medição real com hidrômetros inteligentes que enviam dados em tempo real para um computador", id: "A"},
				]
			},
			"1-2": { // 1.2.1.3
				id: "1-2",				
				type: "textInput",
				label: "Quantos setores da empresa ocorre a medição do consumo de água?",
				options: [
					{ label: "Estimativa por técnicos da empresa", id: "E"},
					{ label: "Medição real com hidrômetros setorizados em cada área e anotação manual por técnicos da empresa", id: "M"},
					{ label: "Medição real com hidrômetros inteligentes que enviam dados em tempo real para um computador", id: "A"},
				]
			},
			"1-3": { // 1.2.1.4
				id: "1-3",				
				type: "textArea",
				label: "Cite os setores onde é realizado o método de medição assinalado.",
				options: [
					{ label: "Estimativa por técnicos da empresa", id: "E"},
					{ label: "Medição real com hidrômetros setorizados em cada área e anotação manual por técnicos da empresa", id: "M"},
					{ label: "Medição real com hidrômetros inteligentes que enviam dados em tempo real para um computador", id: "A"},
				]
			}
		}
	},
	effluentTreatment: {
		id: "effluentTreatment",
		steps: {
			"1": { // 1.3.1
				id: "1",
				type: "tableYear",
				label: "Qual o volume de efluentre em metros cúbicos (m³) gerado mensalmente pela empresa no ano de " + ((new Date()).getFullYear()) + "?",
				options: [
					{label: "", id: "effluentVolume"}
				]
			},
			"2": { // 1.3.2 
				id: "2",				
				type: "radio",
				label: "Onde é realizado o tratamento de efluentes da empresa?",
				options: [
					{ label: "a) 100% do efluente é tratado na própria empresa.", id: "A"},
					{ label: "b) 100% do efluente bruto é enviado para rede coletora para tratamento na ETE do município.", id: "B"},
					{ label: "c) 100% do efluente bruto recebe pré-tratamento na própria empresa e posteriormente é enviado para rede coletora para tratamento na ETE do município.", id: "C"},
					{ label: "d) Parte do efluente é tratado na própria empresa antes de ser lançado no meio ambiente e outra parte é enviada em sua forma bruta para tratamento na ETE do município.", id: "D"},
				]
			},
			"2-1": { // 1.4.2.2
				id: "2-1",				
				type: "checkbox",
				label: "Quais tipos de tratamento são utilizados?",
				options: [
					{ label: "a) Tratamento primário físico-químico (Ex. Gradeamento, Flotação, Decantação, etc)", id: "a"},
					{ label: "b) Tratamento secundário biológico aeróbico (Ex. Lodos Ativados, Lagoa aerada, etc)", id: "b"},
					{ label: "c) Tratamento secundário biológico anaeróbico (Lagoas, Reator UASB, etc)", id: "c"},
					{ label: "d) Tratamento terciário físico-químico (ex. Filtração, Cloração, etc)", id: "d"},
				]
			},
			"2-2": { // 1.3.2.3
				id: "2-2",
				type: "textArea",
				label: "Por favor informe qual é o local de descarte do efluente tratado.",
				options: [
					{id: "description", label: "Resposta."}
				]
			},
			"2-3": { // 1.3.2.1
				id: "2-3",
				type: "rangeInput",
				label: "Qual o percentual é tratado na empresa em relação ao total de efluente gerado?",
				options: [
					{ mask: "%", label: "", id: "efluentGerated",  minRange: "0", maxRange: "100"},
				]
			},
			"2-4": { // 1.4.4
				id: "2-4",
				type: "radio",
				label: "Sua empresa monitora a qualidade dos seus efluentes?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"2-5": { // 1.4.4.1
				id: "2-5",
				type: "textInput",
				label: "Qual a média anual dos parâmetros abaixo dos efluentes gerados pela empresa em " + ((new Date()).getFullYear()) + "?",
				options: [
					{label: "DBO (mg/l)", id: "DBO"},
					{label: "Nitrogênio Amoniacal Total (mg/l).", id: "NAT"},
					// {label: "Em Óxigênio Dissolvido (mg/l)", id: "O"},
				]
			},
		}
	},
	finalProduct: {
		id: "finalProduct",
		steps: {
			"1": { //1.4.1
				id: "1",
				type: "textInput",
				label: "Quais são os principais produtos da empresa?",
				options: [
					{ label: "", id: "products"},
				]
			},
			"2": { // 1.4.2
				id: "2",
				type: "radioWithOther",
				label: "Qual a unidade de medida utilizada pela empresa para quantificar o produto final?",
				options: [
					{ label: "Metro cúbico", id: "a"},
					{ label: "Tonelada", id: "b"},
				]
			},
			"3": { // 1.4.3
				id: "3",
				type: "tableYear",
				label: "Quantidade fabricada de produtos em " + ((new Date()).getFullYear()) + ".",
				options: [
					{ label: "", id: "quantityProduct"},
				]
			},
		},
	},
	input: {
		id: "input",
		steps: {
			"1": {
				id: "1",
				type: "textInput",
				label: "Quais os 3 principais insumos que a empresa produz? (Informar os fundamentais)",
				options: [
					{ label: "1", id: "1"},
					{ label: "2", id: "2"},
					{ label: "3", id: "3"},
				]
			},
			"2": {
				id: "2",
				type: "radioWithOtherDinamic",
				label: "Qual a unidade de medida utilizada pela empresa para quantificar o insumo utilizado ?",
				options: [
					{ label: "Metro cúbico", id: "a" },
					{ label: "Tonelada", id: "b" }
				]
			},
			"3": {
				id: "3",
				type: "dinamic",
				label: "Qual a quantidade de cada Insumo foi utilizada no ano de " + ((new Date()).getFullYear()) + "?",
				options: []
			},
			"4": {
				id: "4",
				type: "location",
				label: "Qual a principal origem deste insumo?",
				options: []
			},
		},
	},
	others: {
		id: "others",
		steps: {
			"1": { // 1.6.1
				id: "1",
				type: "radio",
				label: "Existe refeitório e/ou cozinha para preparo de refeições?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"2": { // 1.6.2
				id: "2",
				type: "radio",
				label: "Os colaboradores tomam banho na empresa?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"2-1": { // 1.6.2.1.
				id: "2-1",
				type: "radio",
				label: "Os chuveiros possuem temporizador/ sensor de presença ou redutores de vazão e pressão da água?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"3": { // 1.6.3
				id: "3",
				type: "radio",
				label: "Os Vasos sanitários instalados nos banheiros possuem caixa acoplada ou acionamento com 2 botões, (3 L e 6L)?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
			"4": { // 1.6.4
				id: "4",
				type: "radio",
				label: "As torneiras dos banheiros e vestiários possuem algum tipo de dispositivo de fechamento automático ou redutores de vazão e pressão da água?",
				options: [
					{ label: "Não", id: "no"},
					{ label: "Sim", id: "yes"},
				],
			},
		}
	}
};



// WEBPACK FOOTER //
// src/models/lib/questions/mensurationQuestions.js